import React, { useState } from "react";
import axios from "axios";
import "./ReviewModal.css";

const ReviewModal = ({ booking, user, closeModal, onReviewSubmitted }) => {
  const [formData, setFormData] = useState({
    name: user.fullName || "",
    date: new Date().toISOString().split("T")[0],
    review: "",
    image: null
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const handleSubmit = async () => {
    const payload = new FormData();
    payload.append("name", formData.name);
    payload.append("date", formData.date);
    payload.append("review", formData.review);
    if (formData.image) payload.append("image", formData.image);

    try {
      const res = await axios.post("/api/review/add-review", payload, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (res.data.success) {
        onReviewSubmitted();
        closeModal();
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong while submitting review");
    }
  };

  return (
    <div className="review-modal-overlay">
      <div className="review-modal">
        <h2>Share Your Experience</h2>

        <label>Your Name</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
        />

        <label>Date</label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
        />

        <label>Your Review</label>
        <textarea
          name="review"
          placeholder="Tell us about your journey..."
          value={formData.review}
          onChange={handleChange}
        />

        <label>Upload a Photo (Optional)</label>
        <input type="file" onChange={handleImageUpload} />

        <div className="review-modal-buttons">
          <button className="review-modal-btn-cancel" onClick={closeModal}>Cancel</button>
          <button className="review-modal-btn-submit" onClick={handleSubmit}>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default ReviewModal;
